import store from "@/store";

export default {
    async GET_NEW_TOURS({commit}){
        try {
            const response = await store.dispatch('customRequests/GET', {
                path: '/tours/my'
            });
            commit('SET_NEW_TOURS', response.data);
        } catch (e) {
            console.error('Error fetching tours:', e);
            throw e;
        }
    },
    async GET_USERS({commit}) {
        try {
            const response = await store.dispatch('customRequests/GET', {
                path: '/users'
            });
            commit('SET_USERS', response.data);
        } catch (e) {
            console.error('Error fetching users:', e);
            throw e;
        }
    },
    async GET_POSTS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/posts/all'
        }).then(response => {
            commit('SET_POSTS', response.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_ROLES({commit}) {
        await store.dispatch('customRequests/GET', {
            path: `/roles`
        }).then(async response => {
            commit('SET_ROLES', response.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_OPERATIONS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: `/roles/operations`
        }).then(async response => {
            commit('SET_OPERATIONS', response.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_ADDITIONAL_PROPS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: `/companies/additional-props`
        }).then(async response => {
            commit('SET_ADDITIONAL_PROPS', response.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_REPORTS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/reports'
        }).then(async response => {
            commit('SET_REPORTS', response.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_FINISHED_TESTS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/tests/all',
            params: {status: ['finished']}
        }).then(async response => {
            commit('SET_FINISHED_TESTS', response.data.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_NOT_FINISHED_TESTS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/tests/all',
            params: {status: ['started', 'new']}
        }).then(async response => {
            commit('SET_NOT_FINISHED_TESTS', response.data.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_GROUPS({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/groups/list',
        }).then(async response => {
            commit('SET_GROUPS', response.data)
        }).catch(e => {
            throw e
        })
    },
    async GET_THEMES({commit}) {
        await store.dispatch('customRequests/GET', {
            path: '/themes',
        }).then(async response => {
            commit('SET_THEMES', response.data)
        }).catch(e => {
            throw e
        })
    }
}